import { Button, Form, Select } from "antd";
import { Fragment, ReactElement, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import Label from "../../components/label/label.component";
import CustomInput from "../../components/custom-input/custom-input.component";
import "./edit-crs.scss";
import TextArea from "antd/es/input/TextArea";
import { PhoneInput } from "react-international-phone";
import { useDispatch } from "react-redux";
import {
  ADD_TO_BREADCRUMB,
  LOADING,
  REMOVE_FROM_BREADCRUMB,
} from "../../store/actions";
import instance from "../../store/axios";
import toast from "react-hot-toast";
import { AxiosResponse } from "axios";
import ReactCountryFlag from "react-country-flag";
import { MinusCircleOutlined, PlusSquareOutlined } from "@ant-design/icons";
import { useForm } from "antd/lib/form/Form";
import CollapseComponent from "../../components/collapse.component";
import BreadcrumbComponent from "../../components/breadcrumb-component/breadcrumb-component";
import { getStandingDataOptions } from "src/utils/helper/functions";
const { Option } = Select;

const EditCrs: React.FC = (): ReactElement => {
  const { accountId, activeKyc } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const isApproveCase = queryParams.get("approve");
  const [form] = useForm();
  Form.useWatch([], form);
  const [usPerson, setUsPerson] = useState<boolean>(false);
  const [crs, setCrs] = useState<boolean>(false);
  const [accountDetails, setAccountDetails] = useState<any>();
  const [countriesData, setCountriesData] = useState([]);
  const [crsValuesArray, setCrsValuesArray] = useState<any>([]);
  const [standingData, setStandingData] = useState<any>();

  useEffect(() => {
    getStandindData();
    getCountriesData();
    getKycApi();

    dispatch({
      type: ADD_TO_BREADCRUMB,
      payload: {
        breadcrumb: [
          {
            text: `Update FATCA & CRS details`,
            type: "text",
          },
        ],
      },
    });

    return () => {
      dispatch({
        type: REMOVE_FROM_BREADCRUMB,
        payload: {
          breadcrumb: [
            {
              text: `Update FATCA & CRS details`,
            },
          ],
        },
      });
    };
  }, []);

  useEffect(() => {
    getCrsSavedValues();
  }, [accountDetails]);

  const onUSPersonChange = (value: string): void => {
    value ? setUsPerson(true) : setUsPerson(false);
  };

  const onCrsChange = (value: string): void => {
    value ? setCrs(true) : setCrs(false);
  };

  const getKycApi = async (): Promise<void> => {
    dispatch({ type: LOADING, payload: true });

    try {
      const response: AxiosResponse<any> = await instance.get(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/account/${accountId}?kycId=${activeKyc}`
      );
      setAccountDetails(response.data.data);
      setUsPerson(response.data.data.accountInfo[0]?.isUsPerson);
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/crs/:${accountId}/:${activeKyc}/edit`
      );
    }

    dispatch({ type: LOADING, payload: false });
  };

  const getCountriesData = async (): Promise<void> => {
    try {
      const response: AxiosResponse<any> = await instance.get(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/option/countries?partial=${1}`
      );
      setCountriesData(response.data.data);
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/crs/:${accountId}/:${activeKyc}/edit`
      );
    }
  };

  const getStandindData = async (): Promise<void> => {
    try {
      const response: AxiosResponse<any> = await instance.get(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/option/standing-data`
      );
      setStandingData(response.data.data);
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/crs/:${accountId}/:${activeKyc}/edit`
      );
    }
  };

  const onSubmit = async (values: any): Promise<void> => {
    dispatch({ type: LOADING, payload: true });

    values.kycId = accountDetails.accountInfo[0]?.id;
    values.branch = "KW";
    if (values.crs?.length) {
      values[`crs1TaxCountryId`] = values.crs[0]
        ? values.crs[0][`crs1TaxCountryId`]
        : null;
      values[`crs1TinExists`] = values.crs[0]
        ? values.crs[0][`crs1TinExists`]
        : null;
      values[`crs1Tin`] = values.crs[0] ? values.crs[0][`crs1Tin`] : null;
      values[`crs1NoTinReasonId`] = values.crs[0]
        ? values.crs[0][`crs1NoTinReasonId`]
        : null;
      values[`crs1ReasonDescription`] = values.crs[0]
        ? values.crs[0][`crs1ReasonDescription`]
        : null;
      values[`crs2TaxCountryId`] = values.crs[1]
        ? values.crs[1][`crs2TaxCountryId`]
        : null;
      values[`crs2TinExists`] = values.crs[1]
        ? values.crs[1][`crs2TinExists`]
        : null;
      values[`crs2Tin`] = values.crs[1] ? values.crs[1][`crs2Tin`] : null;
      values[`crs2NoTinReasonId`] = values.crs[1]
        ? values.crs[1][`crs2NoTinReasonId`]
        : null;
      values[`crs2ReasonDescription`] = values.crs[1]
        ? values.crs[1][`crs2ReasonDescription`]
        : null;
      values[`crs3TaxCountryId`] = values.crs[2]
        ? values.crs[2][`crs3TaxCountryId`]
        : null;
      values[`crs3TinExists`] = values.crs[2]
        ? values.crs[2][`crs3TinExists`]
        : null;
      values[`crs3Tin`] = values.crs[2] ? values.crs[2][`crs3Tin`] : null;
      values[`crs3NoTinReasonId`] = values.crs[2]
        ? values.crs[2][`crs3NoTinReasonId`]
        : null;
      values[`crs3ReasonDescription`] = values.crs[2]
        ? values.crs[2][`crs3ReasonDescription`]
        : null;
    }

    delete values.crs;

    try {
      await instance.post(`/${process.env.REACT_APP_ENDPOINT_VERSION}/account/${accountId}/fatca-info/update`, values);
      toast.success("FATCA & CRS updated successfully");
      navigate(
        `/home/business-account/${accountId}/${activeKyc}/details?tab=8${isApproveCase ? "&approve=1" : ""
        }`
      );
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/crs/:${accountId}/:${activeKyc}/edit${isApproveCase ? "?approve=1" : ""
        }`
      );
    }

    dispatch({ type: LOADING, payload: false });
  };

  const getCrsSavedValues = () => {
    if (accountDetails?.accountInfo[0]?.crs1TaxCountryId) {
      setCrs(true);
    } else {
      setCrs(false);
    }
    if (accountDetails?.accountInfo[0]?.crs1TaxCountryId) {
      setCrsValuesArray((prev: any) => [
        ...prev,
        {
          crs1TaxCountryId: accountDetails?.accountInfo[0]?.crs1TaxCountryId,
          crs1TinExists: accountDetails?.accountInfo[0]?.crs1TinExists,
          crs1Tin: accountDetails?.accountInfo[0]?.crs1Tin,
          crs1ReasonDescription:
            accountDetails?.accountInfo[0]?.crs1ReasonDescription,
          crs1NoTinReasonId:
            accountDetails?.accountInfo[0]?.crs1NoTinReason?.id,
        },
      ]);
    }

    if (accountDetails?.accountInfo[0]?.crs2TaxCountryId) {
      setCrsValuesArray((prev: any) => [
        ...prev,
        {
          crs2TaxCountryId: accountDetails?.accountInfo[0]?.crs2TaxCountryId,
          crs2TinExists: accountDetails?.accountInfo[0]?.crs2TinExists,
          crs2Tin: accountDetails?.accountInfo[0]?.crs2Tin,
          crs2ReasonDescription:
            accountDetails?.accountInfo[0]?.crs2ReasonDescription,
          crs2NoTinReasonId:
            accountDetails?.accountInfo[0]?.crs2NoTinReason?.id,
        },
      ]);
    }

    if (accountDetails?.accountInfo[0]?.crs3TaxCountryId) {
      setCrsValuesArray((prev: any) => [
        ...prev,
        {
          crs3TaxCountryId: accountDetails?.accountInfo[0]?.crs3TaxCountryId,
          crs3TinExists: accountDetails?.accountInfo[0]?.crs3TinExists,
          crs3Tin: accountDetails?.accountInfo[0]?.crs3Tin,
          crs3ReasonDescription:
            accountDetails?.accountInfo[0]?.crs3ReasonDescription,
          crs3NoTinReasonId:
            accountDetails?.accountInfo[0]?.crs3NoTinReason?.id,
        },
      ]);
    }

    return crsValuesArray;
  };

  return (
    <div className="edit-crs-container flex flex-col">
      <BreadcrumbComponent />
      <h2 className=" font-semibold text-xl mb-8">FATCA & CRS</h2>
      {accountDetails && (
        <Form
          scrollToFirstError={true}
          className="add-edit-form"
          initialValues={{
            isUsPerson:
              accountDetails?.accountInfo[0]?.otherNationalityId === 187 ||
                accountDetails?.accountInfo[0]?.nationalityId === 187
                ? true
                : accountDetails?.accountInfo[0]?.isUsPerson,
            tin: accountDetails?.accountInfo[0]?.tin,
            fatcaCountryId: accountDetails?.accountInfo[0]?.fatcaCountryId,
            fatcaBuilding: accountDetails?.accountInfo[0]?.fatcaBuilding,
            fatcaStreet: accountDetails?.accountInfo[0]?.fatcaStreet,
            fatcaAvenue: accountDetails?.accountInfo[0]?.fatcaAvenue,
            fatcaBlock: accountDetails?.accountInfo[0]?.fatcaBlock,
            fatcaZipCode: accountDetails?.accountInfo[0]?.fatcaZipCode,
            fatcaPobox: accountDetails?.accountInfo[0]?.fatcaPobox,
            fatcaTelephone: accountDetails?.accountInfo[0]?.fatcaTelephone,
            additionalDetails:
              accountDetails?.accountInfo[0]?.additionalDetails,
            doYouPay: accountDetails?.accountInfo[0]?.crs1TaxCountryId
              ? true
              : false,
          }}
          form={form}
          // onFieldsChange={() => checkFormErrors()}
          onFinish={onSubmit}
        >
          <CollapseComponent
            header={
              <div className="flex gap-3 items-center">
                <span className="w-[5px] bg-blue-500 h-[25px] rounded-[10px]"></span>
                <h3 className=" text-lg font-semibold">FATCA</h3>
              </div>
            }
          >
            <div className="fields flex justify-space-between wrap">
              <div className="field flex column">
                <Label text="Are you a U.S Person?" />
                <Form.Item
                  name="isUsPerson"
                  rules={[
                    {
                      required: true,
                      message: "Please select Are you a U.S Person?",
                    },
                  ]}
                >
                  <Select
                    placeholder="Are you a U.S Person?"
                    onChange={onUSPersonChange}
                    options={[
                      { value: true, label: "Yes" },
                      { value: false, label: "No" },
                    ]}
                  />
                </Form.Item>
              </div>
            </div>

            {(usPerson ||
              accountDetails?.accountInfo[0]?.otherNationalityId === 187 ||
              accountDetails?.accountInfo[0]?.nationalityId === 187) && (
                <>
                  <h3 className="mb-3">US-based Person</h3>
                  <div className="fields flex justify-space-between wrap">
                    <div className="field flex column">
                      <Label text="Tax Identification No. (TIN)" />
                      <Form.Item
                        name="tin"
                        rules={[
                          {
                            required: true,
                            message: "Please input Tax Identification No. (TIN)!",
                          },
                        ]}
                      >
                        <CustomInput placeholder="Enter Tax Identification No. (TIN)" />
                      </Form.Item>
                    </div>

                    <div className="field flex column">
                      <Label text="Country" />
                      <Form.Item
                        name="fatcaCountryId"
                        rules={[
                          {
                            required: true,
                            message: "Please select Country",
                          },
                        ]}
                      >
                        <Select
                          placeholder="Select birth place - Country"
                          allowClear
                          showSearch
                          filterOption={(input, option: any) => {
                            return (option?.key.toLowerCase() ?? "").includes(
                              input.toLowerCase()
                            );
                          }}
                        >
                          {countriesData?.map((country: any) => (
                            <Option value={country.id} key={country.nameEn}>
                              <div
                                className="flex align-center"
                                style={{ gap: "5px" }}
                              >
                                <ReactCountryFlag
                                  style={{
                                    fontSize: "24px",
                                    marginInlineEnd: "8px",
                                  }}
                                  countryCode={country?.countryCode}
                                  svg
                                />
                                <span>{country.nameEn}</span>
                              </div>
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </div>

                    <div className="field flex column">
                      <Label text="Building" />
                      <Form.Item
                        name="fatcaBuilding"
                        rules={[
                          {
                            required: true,
                            message: "Please input Building!",
                          },
                        ]}
                      >
                        <CustomInput placeholder="Enter Building" />
                      </Form.Item>
                    </div>

                    <div className="field flex column">
                      <Label text="Street" />
                      <Form.Item
                        name="fatcaStreet"
                        rules={[
                          {
                            required: true,
                            message: "Please input Street!",
                          },
                        ]}
                      >
                        <CustomInput placeholder="Enter Street" />
                      </Form.Item>
                    </div>

                    <div className="field flex column">
                      <Label text="Avenue" />
                      <Form.Item name="fatcaAvenue">
                        <CustomInput placeholder="Enter Avenue" />
                      </Form.Item>
                    </div>

                    <div className="field flex column">
                      <Label text="Block" />
                      <Form.Item
                        name="fatcaBlock"
                        rules={[
                          {
                            required:
                              form?.getFieldValue("fatcaCountryId") === 98
                                ? true
                                : false,
                            message: "Please enter the block!",
                          },
                        ]}
                      >
                        <CustomInput placeholder="Enter Block" />
                      </Form.Item>
                    </div>

                    <div className="field flex column">
                      <Label text="Postal Code" />
                      <Form.Item name="fatcaZipCode">
                        <CustomInput placeholder="Enter input Postal Code" />
                      </Form.Item>
                    </div>

                    <div className="field flex column">
                      <Label text="P.O.Box" />
                      <Form.Item name="fatcaPobox">
                        <CustomInput placeholder="Enter input P.O.Box" />
                      </Form.Item>
                    </div>

                    <div className="field flex column">
                      <Label text="Telephone Number Outside Kuwait (if applicable)" />
                      <Form.Item name="fatcaTelephone">
                        <div className="phone-input">
                          <PhoneInput
                            placeholder="Enter Telephone Number Outside Kuwait (if applicable)"
                            value={
                              accountDetails?.accountInfo[0]?.fatcaTelephone || ""
                            }
                            defaultCountry="kw"
                          // onChange={() => setValue("")}
                          />
                          <span className="sub-text">
                            Phone number format: countrycode-phone (Example:
                            +965-00000000)
                          </span>
                        </div>
                      </Form.Item>
                    </div>

                    {/* <div className="fields flex column">
                    <Label text="Additional address details" />
                    <Form.Item name="additionalDetails">
                      <TextArea
                        rows={4}
                        placeholder="Enter Additional address details"
                      />
                    </Form.Item>
                  </div> */}
                  </div>
                </>
              )}
          </CollapseComponent>

          <CollapseComponent
            header={
              <div className="flex gap-3 items-center">
                <span className="w-[5px] bg-blue-500 h-[25px] rounded-[10px]"></span>
                <h3 className="mb-0 text-lg font-semibold">CRS</h3>
              </div>
            }
          >
            <div className="fields flex justify-space-between wrap">
              <div className="field flex column">
                <Label text="Do you pay taxes in countries other than the U.S?" />
                <Form.Item
                  name="doYouPay"
                  rules={[
                    {
                      required: true,
                      message:
                        "Please select Do you pay taxes in countries other than the U.S?",
                    },
                  ]}
                >
                  <Select
                    placeholder="Do you pay taxes in countries other than the U.S?"
                    onChange={onCrsChange}
                    options={[
                      { value: true, label: "Yes" },
                      { value: false, label: "No" },
                    ]}
                  />
                </Form.Item>
              </div>
            </div>

            {crs ? (
              <div className="flex flex-col justify-between w-full">
                <Form.List
                  name="crs"
                  initialValue={
                    accountDetails?.accountInfo[0]?.crs1TaxCountryId
                      ? crsValuesArray
                      : [
                        {
                          crs1TaxCountryId: null,
                          crs1TinExists: null,
                          crs1Tin: null,
                        },
                      ]
                  }
                  rules={[
                    {
                      validator: async (_, names) => {
                        if (!names) {
                          return Promise.reject(new Error("At least 1 CRS"));
                        }
                      },
                    },
                  ]}
                >
                  {(fields: any = 1, { add, remove }, { errors }) => (
                    <Form.Item>
                      <div className="fields flex justify-between flex-wrap">
                        {fields.map((field: any, index: any) => (
                          <Fragment key={index}>
                            <h4 className=" font-semibold w-full">
                              CRS #{index + 1}
                            </h4>

                            <div className="field flex flex-col mt-5">
                              <Label text="Country" />
                              <Form.Item
                                {...field}
                                name={[
                                  field.name,
                                  `crs${index + 1}TaxCountryId`,
                                ]}
                                validateTrigger={["onChange", "onBlur"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Please select country!",
                                  },
                                ]}
                              >
                                <Select
                                  placeholder="Select Country"
                                  showSearch
                                  allowClear
                                  filterOption={(input, option: any) => {
                                    return (
                                      option?.key.toLowerCase() ?? ""
                                    ).includes(input.toLowerCase());
                                  }}
                                >
                                  {countriesData?.map((country: any) => (
                                    <Option
                                      value={country.id}
                                      key={country.nameEn}
                                    >
                                      <div
                                        className="flex align-center"
                                        style={{ gap: "5px" }}
                                      >
                                        <ReactCountryFlag
                                          style={{
                                            fontSize: "24px",
                                            marginInlineEnd: "8px",
                                          }}
                                          countryCode={country?.countryCode}
                                          svg
                                        />
                                        <span>{country.nameEn}</span>
                                      </div>
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </div>
                            <div className="field flex flex-col mt-5">
                              <Label text="Do you have tax identification number?" />
                              <Form.Item
                                {...field}
                                name={[field.name, `crs${index + 1}TinExists`]}
                                validateTrigger={["onChange", "onBlur"]}
                                rules={[
                                  {
                                    required: true,
                                    message:
                                      "Please enter the tax identification number!",
                                  },
                                ]}
                              >
                                <Select
                                  placeholder="Select Do you rely on an investment advisor"
                                  options={[
                                    { value: true, label: "Yes" },
                                    { value: false, label: "No" },
                                  ]}
                                />
                              </Form.Item>
                            </div>
                            {form.getFieldValue("crs")[index] &&
                              typeof form.getFieldValue("crs")[index][
                              `crs${index + 1}TinExists`
                              ] !== "undefined" ? (
                              form.getFieldValue("crs")[index][
                                `crs${index + 1}TinExists`
                              ] ? (
                                <div className="field flex column">
                                  <Label text="Tax Identification number (TIN)" />
                                  <Form.Item
                                    {...field}
                                    name={[field.name, `crs${index + 1}Tin`]}
                                    validateTrigger={["onChange", "onBlur"]}
                                    rules={[
                                      {
                                        required: true,
                                        message:
                                          "Please enter the tax identification number (TIN) !",
                                      },
                                    ]}
                                  >
                                    <CustomInput placeholder="Enter Tax Identification number (TIN)" />
                                  </Form.Item>
                                </div>
                              ) : (
                                <div className="fields flex justify-space-between wrap">
                                  <div className="field flex column">
                                    <Label text="Reason for not having a TIN" />
                                    <Form.Item
                                      {...field}
                                      name={[
                                        field.name,
                                        `crs${index + 1}NoTinReasonId`,
                                      ]}
                                      validateTrigger={["onChange", "onBlur"]}
                                      rules={[
                                        {
                                          required: true,
                                          message:
                                            "Please enter the reason for not having a TIN!",
                                        },
                                      ]}
                                    >
                                      <Select
                                        placeholder="Select reason"

                                        options={[
                                          ...getStandingDataOptions(
                                            standingData,
                                            "CRS_NO_REASON",
                                            ["kw", "gc"],
                                            false
                                          ),
                                        ]}
                                      />
                                    </Form.Item>
                                  </div>

                                  <div className="flex flex-col w-full ">
                                    <Label text="Explain why you are unable to obtain a TIN" />
                                    <Form.Item
                                      {...field}
                                      name={[
                                        field.name,
                                        `crs${index + 1}ReasonDescription`,
                                      ]}
                                      validateTrigger={["onChange", "onBlur"]}
                                      rules={[
                                        {
                                          required: true,
                                          message:
                                            "Please enter the reason for not having a TIN!",
                                        },
                                      ]}
                                    >
                                      <TextArea
                                        rows={4}
                                        placeholder="Explain why you are unable to obtain a TIN"
                                      />
                                    </Form.Item>
                                  </div>
                                </div>
                              )
                            ) : (
                              ""
                            )}
                            {fields.length > 1 ? (
                              <Button
                                className="flex items-center w-full justify-end text-red-600 border-0 bg-transparent mb-2 shadow-none p-0"
                                onClick={() => remove(field.name)}
                              >
                                <MinusCircleOutlined />
                                Delete
                              </Button>
                            ) : null}
                          </Fragment>
                        ))}
                        {fields.length < 3 && (
                          <Form.Item className="w-full">
                            <div className="w-full add-field-button flex justify-start">
                              <Button
                                onClick={() => add()}
                                className=" border-0 text-blue-500 bg-transparent mb-2 shadow-none p-0 text-base"
                                icon={<PlusSquareOutlined />}
                              >
                                Add a CRS
                              </Button>
                            </div>
                            <Form.ErrorList errors={errors} />
                          </Form.Item>
                        )}
                      </div>
                    </Form.Item>
                  )}
                </Form.List>
              </div>
            ) : (
              ""
            )}
          </CollapseComponent>
          <div className="flex w-full flex-wrap items-center justify-end mt-7 pt-5">
            <div className="flex justify-between items-center w-[70%] md:w-[48%]">
              <button
                onClick={() =>
                  navigate(
                    `/home/business-account/${accountId}/${activeKyc}/details?tab=8${isApproveCase ? "&approve=1" : ""
                    }`
                  )
                }
                className="rounded-lg bg-white w-[48%] py-3 text-center outline-0 cursor-pointer text-xs md:text-sm font-semibold border-[1px] border-blue-500 text-blue-500"
              >
                Cancel
              </button>
              <button className="disabled:opacity-50 disabled:cursor-not-allowed rounded-lg bg-blue-500 w-[48%] py-3 text-center outline-0 cursor-pointer text-xs md:text-sm font-semibold border-[1px] border-blue-500 text-white">
                Save
              </button>
            </div>
          </div>
        </Form>
      )}
    </div>
  );
};

export default EditCrs;
